import invert from 'lodash/invert';
import {SearchKeywordSortTypeVo} from '../../common/shared/api/nicolas/vo/SearchKeywordSortTypeVo.enum';
import {SearchThemeKeywordSortTypeVo} from '../../common/shared/api/nicolas/vo/SearchThemeKeywordSortTypeVo.enum';
import {
  SearchKeywordSortType,
  SearchThemeKeywordSortType,
} from '../generated/types';

export function createSearchSortType(
  searchSortTypeVo: SearchSortTypeVo
): SearchSortType {
  return sortTypeVoToSortTypeMap[searchSortTypeVo];
}

export function createSearchSortTypeVo(
  searchSortType: SearchSortType
): SearchSortTypeVo {
  return sortTypeToSortTypeVoMap[searchSortType];
}

type SearchSortTypeVo = SearchKeywordSortTypeVo | SearchThemeKeywordSortTypeVo;

type SearchSortType = SearchKeywordSortType | SearchThemeKeywordSortType;

const sortTypeVoToSortTypeMap: {
  [key in SearchSortTypeVo]: SearchSortType;
} = {
  [SearchKeywordSortTypeVo.Accuracy]: SearchKeywordSortType.Accuracy,
  [SearchKeywordSortTypeVo.Latest]: SearchKeywordSortType.Latest,
  [SearchThemeKeywordSortTypeVo.Popular]: SearchThemeKeywordSortType.Popular,
  [SearchThemeKeywordSortTypeVo.Like]: SearchThemeKeywordSortType.Like,
  [SearchThemeKeywordSortTypeVo.Update]: SearchThemeKeywordSortType.Update,
  [SearchThemeKeywordSortTypeVo.Comment]: SearchThemeKeywordSortType.Comment,
};

type SortTypeToSortTypeVoMap = {
  [key in SearchSortType]: SearchSortTypeVo;
};

const sortTypeToSortTypeVoMap = invert(
  sortTypeVoToSortTypeMap
) as SortTypeToSortTypeVoMap;
